import { authGet } from "@api";
import { DEPLOYMENT_URL } from "@constants";

import { SlackAppNotificationMappingsResponseBody } from "@pages/settings/types";

export const fetchSlackAppNotificationMappings = (deploymentId: string) => {
  return authGet<SlackAppNotificationMappingsResponseBody>(
    `${DEPLOYMENT_URL}/${deploymentId}/slack/channels`
  );
};
